import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import HttpService from "../Servicios/HttpService";
import Membresias from "../components/Membresias/Membresias";
import Miembros from "../components/Miembros/Miembros";
import EditarMiembro from "../components/Miembros/EditarMiembro";
import Usuarios from "../components/Usuarios/Usuarios";
import NuevoMiembro from "../components/Miembros/NuevoMiembro";
import NuevoUsuario from "../components/Usuarios/NuevoUsuario";
import EditarUsuario from "../components/Usuarios/EditarUsuario";
import CambiarPassword from "../components/Usuarios/CambiarPassword";
import Pagos from "../components/Pagos/Pagos";
import RegistrarVisita from "../components/Visitas/RegistrarVisita";
import Visitas from "../components/Visitas/Visitas";
import ConfiguracionComponent from "../components/Configuracion/ConfiguracionComponent";
import InicioComponent from "../components/InicioComponent";
import MiPerfil from "../components/Usuarios/MiPerfil";
import ProductosComponente from "../components/Productos/ProductosComponente.vue";
import ReporteVentas from "../components/Productos/ReporteVentas.vue";
import ScannerQE from "../components/Miembros/ScannerQR.vue";
import Login from "../components/Usuarios/Login.vue";
import GestionClases from "../components/Clases/GestionClases.vue";
import Ejercicio from "../components/Planes/Ejercicio.vue";
import CategoriasEjercicios from "../components/Planes/CategoriasEjercicios.vue";
import Rutinas from "../components/Planes/Rutinas.vue";
import ListaRutinas from "../components/Planes/ListaRutinas.vue";
import AsignarRutina from "../components/Planes/AsignarRutina.vue";
import GestionAsignaciones from "../components/Planes/GestionAsignaciones.vue";
import VentaCarrito from "../components/Productos/VentaCarrito.vue";
import ImportarMiembros from "../components/Miembros/ImportarMiembros.vue";
import GestionRoles from "../components/Usuarios/GestionRoles.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/",
      name: "InicioComponent",
      component: InicioComponent,
      meta: { requiresAuth: true, permiso: "dashboard" }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: InicioComponent,
      meta: { requiresAuth: true, permiso: "dashboard" }
    },
    {
      path: "/membresias",
      name: "Membresias",
      component: Membresias,
      meta: { requiresAuth: true, permiso: "membresias" }
    },
    {
      path: "/miembros",
      name: "Miembros",
      component: Miembros,
      meta: { requiresAuth: true, permiso: "miembros" }
    },
    {
      path: '/miembros/importar',
      name: 'ImportarMiembros',
      component: ImportarMiembros,
      meta: { requiresAuth: true, permiso: "miembros.importar" }
    },
    {
      path: "/scanner",
      name: "ScannerQE",
      component: ScannerQE,
      meta: { requiresAuth: true, permiso: "scanner" }
    },
    {
      path: "/nuevo-miembro",
      name: "NuevoMiembro",
      component: NuevoMiembro,
      meta: { requiresAuth: true, permiso: "miembros.crear" }
    },
    {
      path: "/editar-miembro/:id",
      name: "EditarMiembro",
      component: EditarMiembro,
      meta: { requiresAuth: true, permiso: "miembros.editar" }
    },
    {
      path: "/usuarios",
      name: "Usuarios",
      component: Usuarios,
      meta: { requiresAuth: true, permiso: "usuarios" }
    },
    {
      path: "/nuevo-usuario",
      name: "NuevoUsuario",
      component: NuevoUsuario,
      meta: { requiresAuth: true, permiso: "usuarios.crear" }
    },
    {
      path: "/editar-usuario/:id",
      name: "EditarUsuario",
      component: EditarUsuario,
      meta: { requiresAuth: true, permiso: "usuarios.editar" }
    },
    {
      path: "/roles",
      name: "GestionRoles",
      component: GestionRoles,
      meta: { requiresAuth: true, permiso: "roles" }
    },
    {
      // Cambiar la propia contraseña no depende de ningún permiso de
      // módulo — cualquier usuario autenticado puede hacerlo.
      path: "/cambiar-password",
      name: "CambiarPassword",
      component: CambiarPassword,
      meta: { requiresAuth: true }
    },
    {
      path: "/pagos",
      name: "Pagos",
      component: Pagos,
      meta: { requiresAuth: true, permiso: "reportes_pagos" }
    },
    {
      path: "/registrar-visita",
      name: "RegistrarVisita",
      component: RegistrarVisita,
      meta: { requiresAuth: true, permiso: "visitas" }
    },
    {
      path: "/visitas",
      name: "Visitas",
      component: Visitas,
      meta: { requiresAuth: true, permiso: "reportes_visitas" }
    },
    {
      path: "/configurar",
      name: "Configurar",
      component: ConfiguracionComponent,
      meta: { requiresAuth: true, permiso: "configuracion" }
    },
    {
      // El perfil propio tampoco depende de un permiso de módulo.
      path: "/perfil",
      name: "MiPerfil",
      component: MiPerfil,
      meta: { requiresAuth: true }
    },
    {
      path: "/productos",
      name: "ProductosComponente",
      component: ProductosComponente,
      meta: { requiresAuth: true, permiso: "productos" }
    },
    {
      path: "/venta-carrito",
      name: "VentaCarrito",
      component: VentaCarrito,
      meta: { requiresAuth: true, permiso: "productos" }
    },
    {
      path: "/reporte-ventas",
      name: "ReporteVentas",
      component: ReporteVentas,
      meta: { requiresAuth: true, permiso: "reportes_ventas" }
    },
    {
      path: "/gestion-clases",
      name: "GestionClases",
      component: GestionClases,
      meta: { requiresAuth: true, permiso: "clases" }
    },
    {
      path: "/ejercicios",
      name: "Ejercicio",
      component: Ejercicio,
      meta: { requiresAuth: true, permiso: "ejercicios" }
    },
    {
      path: "/categoria-ejercicio",
      name: "CategoriaEjercicios",
      component: CategoriasEjercicios,
      meta: { requiresAuth: true, permiso: "categorias_ejercicios" }
    },
    {
      path: "/rutinas/crear",
      name: "CrearRutina",
      component: Rutinas,
      meta: { requiresAuth: true, permiso: "rutinas" }
    },
    {
      path: "/rutinas/editar/:id",
      name: "EditarRutina",
      component: Rutinas,
      meta: { requiresAuth: true, permiso: "rutinas" }
    },
    {
      path: "/lista-rutinas",
      name: "ListaRutinas",
      component: ListaRutinas,
      meta: { requiresAuth: true, permiso: "rutinas" }
    },
    {
      path: "/asignar-rutina",
      name: "AsignarRutina",
      component: AsignarRutina,
      meta: { requiresAuth: true, permiso: "asignar_rutina" }
    },
    {
      path: "/gestion-asignaciones",
      name: "GestionAsignaciones",
      component: GestionAsignaciones,
      meta: { requiresAuth: true, permiso: "gestion_asignaciones" }
    },
    {
      path: "*",
      redirect: "/login"
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let isAuthenticated = store.getters.isLoggedIn;

  if (isAuthenticated) {
    try {
      const permisos = await HttpService.obtenerConDatos(
        { metodo: "mis_permisos", idUsuario: store.state.user.idUsuario },
        "usuarios.php"
      );
      store.commit("actualizarPermisos", permisos);
    } catch (error) {
      console.warn("No se pudieron refrescar los permisos, usando los guardados:", error);
    }
  }

  if (requiresAuth && !isAuthenticated) {
    next("/login");
  } else if (to.path === "/login" && isAuthenticated) {
    next("/dashboard");
  } else if (requiresAuth) {
    const permisoRequerido = to.meta.permiso;

  
    if (permisoRequerido && !store.getters.tienePermiso(permisoRequerido)) {
  
      if (to.path !== "/perfil") {
        store.commit("mostrarSnackbar", {
          mensaje: "No tienes permiso para acceder a este módulo.",
          color: "error"
        });
        next("/perfil");
      } else {
        next(false);
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js